import { render, staticRenderFns } from "./HypotheticalTradeReportTemplate.vue?vue&type=template&id=6e1f1710"
import script from "./HypotheticalTradeReportTemplate.vue?vue&type=script&lang=js"
export * from "./HypotheticalTradeReportTemplate.vue?vue&type=script&lang=js"
import style0 from "./HypotheticalTradeReportTemplate.vue?vue&type=style&index=0&id=6e1f1710&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports